import React from 'react';
import styled from 'styled-components';
import { Input, Select, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { PiFolderBold, PiSortAscendingBold, PiFunnelBold } from 'react-icons/pi';
import type { Project_Base } from '~/common/typescript/models/Project';

interface CollectFormFiltersProps {
  searchText: string;
  onSearchChange: (value: string) => void;
  selectedProjectId: number | 'all';
  onProjectChange: (projectId: number | 'all') => void;
  projects: Project_Base[];
  projectsLoading: boolean;
  versionFilter: 'all' | 'v1' | 'v2';
  onVersionFilterChange: (version: 'all' | 'v1' | 'v2') => void;
  sortBy: 'date_desc' | 'date_asc' | 'name_asc' | 'name_desc';
  onSortByChange: (value: 'date_desc' | 'date_asc' | 'name_asc' | 'name_desc') => void;
}

export const CollectFormFilters: React.FC<CollectFormFiltersProps> = ({
  searchText,
  onSearchChange,
  selectedProjectId,
  onProjectChange,
  projects,
  projectsLoading,
  versionFilter,
  onVersionFilterChange,
  sortBy,
  onSortByChange,
}) => {
  const projectOptions = [
    { value: 'all' as const, label: 'Tất cả dự án' },
    ...projects.map((p) => ({
      value: p.id,
      label: p.name || `Dự án #${p.id}`,
    })),
  ];

  return (
    <UI_FiltersWrapper>
      <UI_SearchSection>
        <Input
          placeholder="Tìm kiếm biểu mẫu theo tên, mô tả..."
          prefix={<SearchOutlined style={{ color: '#94a3b8' }} />}
          allowClear
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{ width: '100%', maxWidth: 320, borderRadius: 6 }}
        />
      </UI_SearchSection>

      <UI_FilterGroup>
        <Space size={10} wrap>
          <UI_FilterItem>
            <PiFolderBold size={15} color="#64748b" />
            <Select
              value={selectedProjectId}
              onChange={onProjectChange}
              loading={projectsLoading}
              showSearch
              optionFilterProp="label"
              style={{ width: 220 }}
              options={projectOptions}
              placeholder="Chọn dự án"
            />
          </UI_FilterItem>

          <UI_FilterItem>
            <PiFunnelBold size={14} color="#64748b" />
            <Select
              value={versionFilter}
              onChange={onVersionFilterChange}
              style={{ width: 140 }}
              options={[
                { value: 'all', label: 'Tất cả phiên bản' },
                { value: 'v2', label: 'Chỉ V2' },
                { value: 'v1', label: 'Chỉ V1' },
              ]}
            />
          </UI_FilterItem>

          <UI_FilterItem>
            <PiSortAscendingBold size={14} color="#64748b" />
            <Select
              value={sortBy}
              onChange={onSortByChange}
              style={{ width: 140 }}
              options={[
                { value: 'date_desc', label: 'Mới nhất' },
                { value: 'date_asc', label: 'Cũ nhất' },
                { value: 'name_asc', label: 'Tên (A-Z)' },
                { value: 'name_desc', label: 'Tên (Z-A)' },
              ]}
            />
          </UI_FilterItem>
        </Space>
      </UI_FilterGroup>
    </UI_FiltersWrapper>
  );
};

const UI_FiltersWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background-color: #f8fafc;
  border-bottom: 1px solid #f1f5f9;
  gap: 12px;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const UI_SearchSection = styled.div`
  flex: 1;
`;

const UI_FilterGroup = styled.div`
  display: flex;
  align-items: center;
`;

const UI_FilterItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
